import React from 'react';
import FormWizard from '../FormWizard';
import CellPhoneForm from './CellPhoneForm';

const CellPhoneFormPage = () => {
  return (
    <FormWizard 
      formId={8}
      formTitle="iPad - Cell Phone"
      formTitleEs="iPad - Celular"
    >
      <CellPhoneForm />
    </FormWizard>
  );
};

export default CellPhoneFormPage;

